import React from "react";
import { Outlet } from "react-router-dom";

function DoctorOpdLayout() {
  return <Outlet />;
}

export default DoctorOpdLayout;